import React from 'react';
import SectionHeadingStyle3 from '../../SectionHeading/SectionHeadingStyle3';
import Accordion from '../../Accordion';
import { Icon } from '@iconify/react';

export default function FaqSection({
  sectionTitleUp,
  sectionTitle,
  sectionSubTitle,
  bgImgUrl,
  imgUrl,
  iconUrl,
  data,
  featureTitle,
  featureList,
}) {
  return (
    <>
      <div className="position-relative cs_zindex_1">
        <div className="container position-relative cs_zindex_1">
          <div className="row align-items-end">
            <div className="col-lg-6 cs_pr_0 cs_pr_lg_12 cs_pt_lg_60">
              <div className="cs_faq cs_style_1 cs_pt_70 cs_pb_70 cs_pl_70 cs_pr_70 cs_pl_lg_25 cs_pr_lg_25 bg-white shadow-lg">
                <SectionHeadingStyle3
                  sectionTitleUp={sectionTitleUp}
                  sectionTitle={sectionTitle}
                  sectionSubTitle={sectionSubTitle}
                  className="cs_mb_54"
                />
                <Accordion data={data} />
              </div>
            </div>
   
          </div>
        </div>
        <div
          className="cs_faq-1-bg background-filled position-absolute start-0 top-0 w-100"
          style={{ backgroundImage: `url(${bgImgUrl})` }}
        />
      </div>
    
    </>
  );
}
